module.exports = __webpack_public_path__ + "assets/chat-f439ae.svg";